import Fade from "../../../shared/Fade";
import MoveBack from "../../../shared/MoveBack";

const TossTerms: React.FC = () => {
  return (
    <Fade>
      <div>
        <MoveBack pageBefore="/money-split/toss-auth" />
        <div style={{ margin: "20px" }}>
          <strong>개인정보 수집·이용 동의</strong>
          <br />
          <br />
          <div>
            주식회사 비바리퍼블리카는 「개인정보보호법」, 「신용정보법」, 「전자금융거래법」, 「전자상거래법」,
            「전자서명법」, 「정보통신망법」 등 관련 법령에 따라 이용자로부터 아래와 같은 개인정보 수집·이용·제공 및
            활용 동의를 받고자 합니다. 내용을 자세히 읽으신 후, 동의하시면 원래 화면으로 돌아가 “동의”, “계속”,
            “인증번호받기” 등 해당 화면의 안내에 따라 버튼을 눌러 주시기 바랍니다. 보다 자세한 내용은 회사의 개인정보
            처리방침을 참조하여 주시기 바랍니다.
          </div>
          <br />
          <ul style={{ paddingInlineStart: "10px" }}>
            <li>
              처리 목적 : 토스 회원 여부 식별을 통한 사용자 정보의 유일성 확인 토스 전자인증서비스를 통한 인증서비스 및
              본인확인서비스 이용 서비스 관련 민원 및 분쟁 처리
            </li>
            <li>처리 항목 : 이름, 생년월일, 휴대전화번호</li>
            <li>보유 및 이용기간 : 이용 목적 달성 시까지 또는 관계 법령에서 정하는 경우 해당 기간까지 보유</li>
          </ul>
          <br />
          <div>
            동의를 거부하는 경우에 대한 안내: 본 동의는 토스 전자인증서비스(인증서비스 및 본인확인서비스)를 위한
            필수적인 동의이므로, 동의를 하지 않으면 해당 서비스를 이용할 수 없습니다. 동의를 거부하는 경우에도 다른 토스
            서비스의 이용에는 영향이 없습니다.
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default TossTerms;
